import {IFetchContext} from "@pg-mono/data-fetcher";
import {rpAppPath} from "@pg-mono/rp-routes";

import {IRPRequestMeta} from "../../app/rp_request_meta";
import {MetaDataDispatch, updateMetaData} from "../../meta_data/actions/update_meta_data";
import {defaultMetaData} from "../../meta_data/reducers/meta_data_reducer";

export const updateForYouMeta = (ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: MetaDataDispatch) => {
    const metaData = updateMetaData({
        title: "Znajdziemy dla Ciebie idealne mieszkanie - bezpłatna pomoc na rynekpierwotny.pl",
        description: defaultMetaData.description,
        pathname: ctx.route.pathname,
        customCanonicalPath: rpAppPath.weFindForYou.base
    });

    dispatch(metaData);
    return true;
};
import {IFetchContext} from "@pg-mono/data-fetcher";
import {rpAppPath} from "@pg-mono/rp-routes";

import {IRPRequestMeta} from "../../app/rp_request_meta";
import {MetaDataDispatch, updateMetaData} from "../../meta_data/actions/update_meta_data";
import {defaultMetaData} from "../../meta_data/reducers/meta_data_reducer";

export const updateForYouMeta = (ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: MetaDataDispatch) => {
    const metaData = updateMetaData({
        title: "Znajdziemy dla Ciebie idealne mieszkanie - bezpłatna pomoc na rynekpierwotny.pl",
        description: defaultMetaData.description,
        pathname: ctx.route.pathname,
        customCanonicalPath: rpAppPath.weFindForYou.base
    });

    dispatch(metaData);
    return true;
};
